import { render, staticRenderFns } from "./IntroBanner.vue?vue&type=template&id=880a3734&scoped=true&"
import script from "./IntroBanner.vue?vue&type=script&lang=js&"
export * from "./IntroBanner.vue?vue&type=script&lang=js&"
import style0 from "./IntroBanner.vue?vue&type=style&index=0&id=880a3734&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880a3734",
  null
  
)

export default component.exports